import { Box, Typography } from "@material-ui/core";
import {
  Bluetooth,
  Book,
  DeviceUnknown,
  Mail,
  Public,
  Usb,
} from "@material-ui/icons";
import {
  Button,
  DateField,
  FunctionField,
  ListButton,
  Record,
  Show,
  ShowActionsProps,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useShowController,
} from "react-admin";
import { useHistory } from "react-router-dom";
import {
  FmcsaInspectionDto,
  FmcsaInspectionReportType,
} from "../../../common/data/service-proxies";
import { ViewFmcsaDataTransferActions } from "./ViewFmcsaDataTransferActions";
import { useAppData } from "../../../common/hooks/useAppData";

const Actions = (props: ShowActionsProps) => {
  const { basePath, data } = props;
  const history = useHistory();
  return (
    <TopToolbar>
      <Button
        label="Go to log"
        onClick={() =>
          history.push(`/hos-driver-log-view/${data?.driverId}/${data?.time}`)
        }
      >
        <Book />
      </Button>
      <ListButton
        basePath={basePath}
        label="resources.common.labels.backToList"
      />
    </TopToolbar>
  );
};

export const ViewFmcsaDataTransfer = (props: any) => {
  const { record } = useShowController(props);
  const timeZone = useAppData((x) => x.timeZoneInfo);

  return (
    <Show {...props} title="View FMCSA inspection" actions={<Actions />}>
      <SimpleShowLayout>
        <TextField source="driverDriverId" label="Driver ID" />
        <TextField source="driverFullName" label="Name" />
        <TextField source="vehicleName" label="Vehicle" />
        <DateField
          source="time"
          showTime
          label="Time"
          options={{ timeZone: timeZone?.ianaTimeZone }}
        />
        <DateField
          source="reportTimeFrom"
          label="Report period start"
          options={{ timeZone: timeZone?.ianaTimeZone }}
        />
        <DateField
          source="reportTimeTo"
          label="Report period end"
          options={{ timeZone: timeZone?.ianaTimeZone }}
        />
        <FunctionField<FmcsaInspectionDto & Record>
          label="Report type"
          source="reportType"
          render={(record) => (
            <Box className="mobile-app-container">
              {record?.reportType === FmcsaInspectionReportType.Bluetooth ? (
                <>
                  <Bluetooth />
                  <Typography variant="body2">Bluetooth</Typography>
                </>
              ) : record?.reportType === FmcsaInspectionReportType.Email ? (
                <>
                  <Mail />
                  <Typography variant="body2">E-Mail</Typography>
                </>
              ) : record?.reportType === FmcsaInspectionReportType.TestEmail ? (
                <>
                  <Mail />
                  <Typography variant="body2">E-Mail (test)</Typography>
                </>
              ) : record?.reportType === FmcsaInspectionReportType.TestWeb ? (
                <>
                  <Public />
                  <Typography variant="body2">Web service (test)</Typography>
                </>
              ) : record?.reportType === FmcsaInspectionReportType.Usb ? (
                <>
                  <Usb />
                  <Typography variant="body2">USB</Typography>
                </>
              ) : record?.reportType === FmcsaInspectionReportType.Web ? (
                <>
                  <Public />
                  <Typography variant="body2">Web service</Typography>
                </>
              ) : (
                <DeviceUnknown />
              )}
            </Box>
          )}
        />
        {record?.reportEmailRecipient ? (
          <TextField
            source="reportEmailRecipient"
            label="E-mail recipient override"
          />
        ) : null}
        <TextField source="eldFileComment" label="File comment" emptyText="-" />
        <ViewFmcsaDataTransferActions />
      </SimpleShowLayout>
    </Show>
  );
};
